import React, { useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Hero } from "../Constants";
import "./qr.css";

const SITE_URL = "https://vilnohirsk-memory.site";
const heroUrl = (id) => `${SITE_URL}/person/${id}`;

export const QRCard = ({ hero }) => {
  const ref = useRef(null);

  const downloadSvg = () => {
    const svg = ref.current.querySelector("svg");
    const data = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([data], { type: "image/svg+xml" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `qr-person-${hero.id}.svg`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="qr-card">
      <img className="qr-card__photo" src={hero.photo} alt={hero.name} />
      <h2 className="qr-card__name">{hero.name}</h2>
      <p className="qr-card__date">{hero.date}</p>
      <p className="qr-card__pos">{hero.position}</p>

      <div ref={ref} className="qr-card__code">
        <QRCodeSVG
          value={heroUrl(hero.id)}
          size={512}
          level="Q"
          marginSize={4}
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>

      <p className="qr-card__hint">
        Наведіть камеру телефона, щоб прочитати історію Героя
      </p>
      <p className="qr-card__site">vilnohirsk-memory.site</p>
      <p className="qr-card__glory">Вічна слава Героям!</p>

      <button className="qr-card__btn no-print" onClick={downloadSvg}>
        Завантажити SVG
      </button>
    </div>
  );
};

// /qr/3 — один герой
export const QRPage = () => {
  const { id } = useParams();
  const hero = Hero.find((h) => h.id === +id);
  if (!hero) return <p>Героя не знайдено</p>;
  return (
    <div className="qr-page">
      <div className="no-print">
        <button onClick={() => window.print()}>Друк / PDF</button>{" "}
        <Link to="/qr">Усі герої</Link>
      </div>
      <QRCard hero={hero} />
    </div>
  );
};

// /qr — усі герої, кожен на окремому аркуші A4
export const QRAll = () => (
  <div className="qr-page">
    <div className="no-print">
      <button onClick={() => window.print()}>Друкувати все (PDF)</button>
    </div>
    {Hero.map((h) => (
      <QRCard key={h.id} hero={h} />
    ))}
  </div>
);